@if (business) {
  <div class="bp-container">
    <h4 class="bp-title">{{ business.name || business.businessId }}</h4>

    <div class="bp-section">
      <h5>Roles</h5>
      @if (business.roles.length > 0) {
        <div class="roles-list">
          @for (role of business.roles; track role.roleName) {
            <button
              type="button"
              class="role-pill role-filter"
              [class.active]="selectedRoleNames.has(role.roleName)"
              (click)="toggleRoleFilterName(role.roleName)"
            >
              {{ role.displayName || role.roleName }}
            </button>
          }
        </div>
        @if (selectedRoleNames.size > 0) {
          <div class="role-filter-toolbar">
            <span class="role-filter-hint">Filtering permissions granted by selected roles.</span>
            <button type="button" class="btn-clear" (click)="clearRoleFilter()">Clear filter</button>
          </div>
        }
      } @else {
        <span class="no-roles">No roles assigned for this business</span>
      }
    </div>

    <div class="bp-section">
      <h5>Permissions</h5>
      @if (business.permissions.length > 0) {
        <div class="bp-permissions-grid">
          <div class="bp-permissions-list">
            @for (group of groupedPermissions; track (group.category || 'Uncategorized')) {
              <div class="perm-category">
                <h6 class="perm-category-title">{{ group.category }}</h6>
                <div class="perm-category-items">
                  @for (p of group.items; track p.code) {
                    <button class="perm-item" (click)="onSelectPermission(p)" [class.active]="selectedPermission?.code === p.code">
                      <span class="perm-code">{{ p.code }}</span>
                      <span class="perm-name">{{ p.name }}</span>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
          <div class="bp-permission-detail">
            @if (selectedPermission) {
              <h5 class="perm-detail-title">{{ selectedPermission.name }} <span class="perm-detail-code">({{ selectedPermission.code }})</span></h5>
              <div class="perm-meta">
                <span class="meta">Category: {{ selectedPermission.category }}</span>
              </div>
              @if (selectedPermission.description) {
                <p class="perm-desc">{{ selectedPermission.description }}</p>
              } @else {
                <p class="perm-desc empty">No description available for this permission.</p>
              }
            } @else {
              <div class="urp-empty"><p>Select a permission to view details.</p></div>
            }
          </div>
        </div>
      } @else {
        <span class="no-roles">No permissions for this business</span>
      }
    </div>
  </div>
} @else {
  <div class="urp-empty">
    <p>Select a business to view roles and permissions.</p>
  </div>
}
